import type { ScheduleEntry } from './schedule'
import { effectiveSpanDates } from './schedule-span'

export type ScheduleDaySummary = { hasHunts: boolean; hasEvents: boolean }

export function summarizeScheduleDays(
  entries: ScheduleEntry[],
): Record<string, ScheduleDaySummary> {
  const map: Record<string, ScheduleDaySummary> = {}

  for (const entry of entries) {
    if (entry.status === 'cancelled') continue

    for (const dateKey of effectiveSpanDates(entry)) {
      if (!map[dateKey]) map[dateKey] = { hasHunts: false, hasEvents: false }
      if (entry.type === 'hunt') map[dateKey].hasHunts = true
      if (entry.type === 'event') map[dateKey].hasEvents = true
    }
  }

  return map
}
